import http from './index';
/**
 * 根据状态获得激活码列表
 * @param params 根据状态获得激活码列表参数
 * @param params.jsonData JSON字符串，"user_id":4,"status":""
 * @param params.jsonData.status 状态 查询全部时传0传为未激活,1为已激活
 * @returns Promise 根据状态获得激活码列表结果
 * @example
 * getActiveCodeApi({ jsonData: {"user_id":4,"status":""} })
 */
export const getActiveCodeApi = (params) => {
  return http.get('mallApi/getActiveCode', { params });
};

/**
 * 获得商品列表
 * @param params 获得商品列表参数
 * @param params.jsonData JSON字符串，"user_id":4
 * @returns Promise 获得商品列表结果
 * @example
 * getMallInfoApi({ jsonData: {"user_id":4} })
 */
export const getMallInfoApi = (params) => {
  return http.get('mallApi/getMallInfo', { params });
};

/**
 * 生成支付订单
 * @param params 生成支付订单参数
 * @param params.jsonData JSON字符串，"user_id":4,"mall_id":"1","scene_type":"mini"
 * @param params.jsonData.mall_id 商品id
 * @param params.jsonData.scene_type mini小程序支付,h5网页支付
 * @returns Promise 生成支付订单结果
 * @example
 * payCodeApi({ jsonData: {"user_id":4,"mall_id":"1","scene_type":"mini"} })
 */
export const payCodeApi = (params) => {
  return http.get('mallApi/payCode', { params });
};

/**
 * 微信公众号登录
 * @param params 微信公众号登录参数
 * @param params.jsonData JSON字符串，"code":4 公众号code
 * @returns Promise 微信公众号登录结果
 * @example
 * wxLoginApi({ jsonData: {"code ": xxx,} })
 */

export const wxLoginApi = (params) => {
  return http.post('wxApi/wxMpLogin', params);
};

/**
 * 获得作品封面
 * @param params 获得作品封面参数
 * @param params.jsonData JSON字符串，"user_id":4,"page":1,"rows":25
 * @param params.jsonData.mall_id 商品id
 * @param params.jsonData.scene_type mini小程序支付,h5网页支付
 * @returns Promise 获得作品封面结果
 * @example
 * payCodeApi({ jsonData: {"user_id":4,"page":1,"rows":25 } })
 */
export const getWorksPhotoApi = (params) => {
  return http.get('mallApi/getWorksPhoto', { params });
};

/**
 * 获取微信 JSSDK 配置
 * @param params 获取微信 JSSDK 配置参数
 * @param params.jsonData JSON字符串，"url": 当前页面URL
 * @returns Promise 获取微信 JSSDK 配置结果
 * @example
 * getWxConfigApi({ jsonData: {"url": window.location.href} })
 */
export const getWxConfigApi = (params) => {
  return http.get('wxApi/getWxConfig', { params });
};

export default {
  getActiveCodeApi,
  getMallInfoApi,
  payCodeApi,
  wxLoginApi,
  getWorksPhotoApi,
  getWxConfigApi,
};
